import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { TemplateKind } from 'src/app/enums/templateKind.enum';
import { AuthService } from 'src/app/services/auth.service';
import { PermissionService } from 'src/app/services/permission.service';
import { TEMPLATE_KIND_QUERY_PARAM } from 'src/app/shared/constants/templateKind.constants';
import { canUseSurveyTemplates, resolveTemplateKind } from 'src/app/shared/helpers/template-kind.helper';

@Component({
  standalone: false,
  selector: 'app-template-list-host',
  templateUrl: './template-list-host.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TemplateListHostComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly authService = inject(AuthService);
  private readonly permissionService = inject(PermissionService);

  readonly templateKind = TemplateKind;
  readonly kind$: Observable<TemplateKind> = this.route.queryParamMap.pipe(
    map(params => resolveTemplateKind(
      params.get(TEMPLATE_KIND_QUERY_PARAM),
      canUseSurveyTemplates(this.authService, this.permissionService)
    )),
    distinctUntilChanged()
  );
}
